import script from "./TawafPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TawafPage.vue?vue&type=script&setup=true&lang=js"

import "./TawafPage.vue?vue&type=style&index=0&id=3b024b1f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b024b1f"]])

export default __exports__